import { render } from "./PersonalAppeals.vue?vue&type=template&id=bf54adc2&scoped=true"
import script from "./PersonalAppeals.vue?vue&type=script&lang=js"
export * from "./PersonalAppeals.vue?vue&type=script&lang=js"

import "./PersonalAppeals.vue?vue&type=style&index=0&id=bf54adc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf54adc2"]])

export default __exports__